// Mock data pour le site Tamila Hachemi
import { contactInfo } from "./config/siteConfig";

// Les coordonnées (téléphone, email, adresse) viennent de siteConfig.js,
// source unique de vérité utilisée aussi bien ici que sur la page Contact.
export const siteInfo = {
  name: "Tamila Hachemi",
  title: "Psychologue & Psychothérapeute à Marseille",
  tagline: "Profitez de mon accompagnement bienveillant pour avancer dans votre chemin de vie !",
  address: contactInfo.address,
  phone: contactInfo.phone,
  email: contactInfo.email,
  hours: "Lundi - Vendredi : 9h00 - 19h00"
};

// Domaines d'accompagnement, tirés de la plaquette (présentation p. 2,
// approche intersectionnelle p. 5, exemples des formules p. 12-13).
export const specializations = [
  "Identités culturelles et origines",
  "Genre et sexualité : coming-out, transition de genre",
  "Neuroatypie : TDAH, HPI",
  "Spiritualité",
  "Anxiété, dépression, burn-out",
  "Épreuves de vie : deuil, séparation, parcours PMA"
];

// Le texte de présentation "Qui suis-je ?" vit désormais dans
// src/data/aboutContent.js (contenu de la plaquette, section A).

// TODO [À COMPLÉTER] : vrais témoignages de patient·e·s (avec leur accord).
// Emplacements prêts à être remplis — on n'affiche pas de faux témoignages.
export const testimonials = [
  { id: 1, isPlaceholder: true },
  { id: 2, isPlaceholder: true },
  { id: 3, isPlaceholder: true }
];

// Les créneaux de rendez-vous ne sont plus codés en dur : ils sont lus dans
// l'agenda Google de la psychologue (voir google-apps-script/ et
// src/services/bookingApi.js).

export const freudQuote = {
  text: "Les émotions inexprimées ne meurent jamais. Elles sont enterrées vivantes et ressurgissent plus tard de façon plus laide.",
  author: "Sigmund Freud"
};
